module.exports = __webpack_public_path__ + "img/no-data.49f19729.svg";